/**
 * @license ResortSuite Web Copyright (c) 2012-2016, Enablez Inc. All Rights Reserved.
 * build: @@buildrsweb@@
 */

 require.config({
    paths:{
        jquery:'lib/jquery',
        jquerymigrate:'lib/jquery.migrate',
        jqueryui:'lib/jquery.ui.core',
        jqueryuidatepicker:'lib/jquery.ui.datepicker',
        underscore:'lib/underscore',
        moment:'lib/moment',
        moment_tz:'lib/moment-timezone-with-data-2012-2022',
        date:'lib/date',
        text:'lib/text',
        order:'lib/order',
        json2:'lib/json2',
        bootstrap:'lib/bootstrap',
        enquire:'lib/enquire',
        director:'lib/director-1.0.7',
        jquery_cookie:'lib/jquery.cookie',
        jquery_validate:'lib/jquery.validate',
        jquery_xml2json:'lib/jquery.xml2json',
        jquery_hashchange:'lib/jquery.ba-hashchange',
        rsweblib:'lib/rsweblib',
        Handlebars:'lib/handlebars',
        hbs:'lib/hbs',
        Customization:'customization/Customization',
        pointer_events_polyfill: 'lib/pointer_events_polyfill',
        showdown: 'lib/showdown',
        jquerymask: 'lib/jquery.mask',
        'Vue': 'lib/vue',
        'vue': 'lib/requirejs-vue',
        'vuex': 'lib/vuex',
        'signaturePad': 'lib/jquery.signaturepad',
        'es6-promises': 'lib/es6-promise',
        'es6-promises-auto': 'lib/es6-promise.auto',
        'persisted-state' : 'lib/vuex-persistedstate.umd',
        'helpers' : 'app/views/vue/helpers',
        'vues':'app/views/vue/vue-starter',
        'vuejsDatepicker':'lib/vuejs-datepicker.min',
        'zxcvbn':'lib/zxcvbn',
        'vuedate':'lib/vuedate.min',
        'vuecal': 'lib/vuecal.umd',
        'dateOfBirthPicker':'lib/vueDatePick.min',
        'DataTable': 'lib/datatables.min',
        'basicComponents': 'app/views/vue/basicComponents',
        'vue_scrollbar': "lib/vue2-scrollbar.min",
        'vue_sticky':"lib/vue-sticky-directive.min",
        "PerfectScrollbar":"lib/vue2-perfect-scrollbar.umd.min",
        'modeSelector': "app/views/vue/mode-select-vue-app",
        'optionalClassProgram': "app/views/vue/optional-class-program",
        'loginVueApp': "app/views/vue/login-vue"
    },
    hbs:{
        templateExtension:'html',
        helperDirectory:'app/views/templates/helpers/',
        i18nDirectory:'app/views/templates/i18n/',
        // if disableI18n is `true` it won't load locales and the i18n helper
        // won't work as well.
        disableI18n:true,
        handlebarsPath:'Handlebars',
        excludeHandlebars:false
    },
    shim: {
        'jquerymigrate' : ['jquery'],
        'jqueryui' : ['jquery'],
        'jqueryuidatepicker' : ['jquery'],
        'jquery_cookie' : ['jquery'],
        'jquery_validate' : ['jquery'],
        'jquery_xml2json' : ['jquery'],
        'jquery_hashchange' : ['jquery'],
        'jquerymask' : ['jquery'],
        "Vue": {"exports": "Vue"}
    },
    waitSeconds:60
});

window.app = {
    controllers: {},
    views: {},
    models: {}
};

window.noconsolelogging = false;
//>>excludeStart('excludeAfterBuild', pragmas.excludeAfterBuild)
window.noconsolelogging = false;

//>>excludeEnd('excludeAfterBuild')


// Load our app
define('rsweb', [
    'jquery',
    'jquerymigrate',
    'underscore',
    'lib/event',
    'lib/pickLanguage',
    'app/dispatcher',
    'Customization',
    'json2',
    'jquery_cookie',
    'rsweblib',
    'app/app',
    'pointer_events_polyfill'
    ,'lib/hbs/controllerSham'
], function ($, querymigrate, _, Event, pickLanguage, Dispatcher, Customization, json2, jqc, rs, RSWebJS, PointerEventsPolyfill) {

        jQuery.ajaxPrefilter( function( s ) {
            if ( s.crossDomain ) {
                s.contents.script = false;
            }
        } );

        PointerEventsPolyfill.initialize({});

        if(!window.console || window.noconsolelogging ) {
            if (!!window.console) {
                window._console = window.console;
            }
            window.console = { log: function(){}, error: function(){}}
        } else if (!window.console.log) {
            window.console.log = function(){}
        }


        var rswebjs = new RSWebJS($, _, Event, pickLanguage, Dispatcher, Customization, rs)
        window.app = $.extend(rswebjs, window.app);
        return window.app
    }
);
require(['rsweb'],function(rswebjs){
    rswebjs.init();
})
;
